import { Injectable, inject } from '@angular/core';
import { FirebaseError } from 'firebase/app';
import { AuthProvider, FacebookAuthProvider, GoogleAuthProvider, OAuthCredential, OAuthProvider, User, linkWithCredential, signInWithCredential, signInWithCustomToken, signInWithPopup } from 'firebase/auth';
import { FIREBASE_AUTH } from './firebase-auth.token';

@Injectable({ providedIn: 'root' })
export class FirebaseSocialAuthGateway {
  private readonly auth = inject(FIREBASE_AUTH);
  signIn(provider: AuthProvider) { return signInWithPopup(this.auth, provider); }
  credentialFromError(error: FirebaseError, providerId: string) {
    if (providerId === 'facebook.com') return FacebookAuthProvider.credentialFromError(error);
    if (providerId === 'google.com') return GoogleAuthProvider.credentialFromError(error);
    return OAuthProvider.credentialFromError(error);
  }
  link(user: User, credential: OAuthCredential) { return linkWithCredential(user, credential); }
  signInCustomToken(token: string) { return signInWithCustomToken(this.auth, token); }
  signInCredential(credential: OAuthCredential) { return signInWithCredential(this.auth, credential); }
}
